import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Scrolls window to top whenever the route pathname changes.
 * Fixes the "stayed on old scroll position after navigating" issue.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    // Use setTimeout to run after the new page mounts so scroll actually takes effect
    const t = setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    }, 0);
    return () => clearTimeout(t);
  }, [pathname]);
  return null;
};

export default ScrollToTop;
